import apiClient from './apiClient';

export const sendEmailRescue = async (email) => {
    try {
        const response = await apiClient.post('auth/email-rescue', { email });
        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(error.response?.data?.error || error.message)
    }
};
